import React from 'react';
import withAuthorization from 'components/Session/withAuthorization';
import { Typography } from '@material-ui/core';
import SectionFooter from 'views/SectionFooter';
import GuideHeader from '../../components/GuideHeader';
import GuideContent from '../../components/GuideContent';
import GuideSection from '../../components/GuideSection';
import QuestionsToAsk from './QuestionsToAsk';
import DownloadGuideButton from './DownloadGuideButton';
import ContentList from './ContentList';
import MeditateSection from './MeditateSection';

const Spirit = () => {
  return (
    <>
      <GuideHeader
        name="Spirit"
        cdnId="app_images/spirit-wide-arms"
        text="Spiritual practices equate to better health and overall wellbeing. Within this guide I will highlight a few
          ways to strengthen your spiritual connection."
      />
      <GuideContent>
        <GuideSection>
          <Typography variant="h5" gutterBottom>
            RECOGNIZE YOUR CREATOR
          </Typography>
          <Typography variant="body1" gutterBottom>
            Quiet time alone will help you develop more peace, patience and joy in your life.
          </Typography>
          <ContentList>
            <Typography variant="body1" gutterBottom>
              <strong>Recognize</strong> there is a power in the universe greater than yourself, however you define it.
            </Typography>
            <Typography variant="body1" gutterBottom>
              <strong>Invest</strong> time in thought and prayer.
            </Typography>
            <Typography variant="body1" gutterBottom>
              <strong>Explore</strong> your beliefs and values (these are the core of who you are)
            </Typography>
          </ContentList>
          <QuestionsToAsk questions={['Who am I?', 'What is my purpose?', 'What are my values and beliefs?']} />
        </GuideSection>
        <MeditateSection />
        <GuideSection>
          <Typography variant="h5" gutterBottom>
            GRATITUDE JOURNAL
          </Typography>
          <Typography variant="body1" gutterBottom>
            Gratitude allows you to be more purposeful and humble showing more love to others.
          </Typography>
          <ContentList>
            <Typography variant="body1" gutterBottom>
              <strong>Write down</strong> 3 things that you are grateful for at the start and end of your day.
            </Typography>
            <Typography variant="body1" gutterBottom>
              <strong>Show off</strong> your gratitude by serving others.
            </Typography>
            <Typography variant="body1" gutterBottom>
              <strong>Use resources</strong> like the ‘Best Self-Journal.’
            </Typography>
          </ContentList>
        </GuideSection>

        <DownloadGuideButton storagePath="guides/spirit-guide.pdf" type="Spirit" />
      </GuideContent>
      <SectionFooter />
    </>
  );
};

export default withAuthorization()(Spirit);
